function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP TextInput component
 * 
 */

import * as React from 'react';
import ErrorMessage from '../error-message/ErrorMessage';
import Info from '../info/Info';
import { FIELD_LENGTH, FIELDS } from '../../data/Data';
import './TextInput.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const RANDOM = (Math.random() * 1000).toFixed(0);
class TextInput extends React.Component {
  render() {
    let {
      autoComplete,
      onBlur,
      handleChange,
      info,
      inputMode,
      jest,
      label,
      name,
      placeholder,
      section,
      submit,
      type,
      values
    } = this.props;
    // $FlowFixMe
    let {
      display,
      error,
      required,
      valid,
      value
    } = values[name] ? values[name] : {
      display: '',
      error: false,
      required: false,
      valid: null,
      value: ''
    };
    const id = section ? `${section}_${name}` : name;
    const classes = `form-element-container ${name}${error ? ' error' : ''}${valid ? ' valid' : ''}`;
    let errorMessage = '';
    const toggleValue = ['licenceDeliveryAddressCountry', 'EPS_CARDNUMBER', 'CardNumber', 'card_number'];
    const length = name === 'licenceNumber' ? 15 : FIELD_LENGTH;
    if (autoComplete === 'off' && !jest) {
      autoComplete = `autoCompleteOff_${RANDOM}`;
    }
    switch (true) {
      case valid === null:
        errorMessage = `${label} is required`;
        break;
      case valid === false && value.length > length:
        errorMessage = `${label} exceeds the limit of ${length} characters`;
        break;
      case valid === false && value.length === 0:
        errorMessage = `${label} is required`;
        break;
      case valid === false:
        errorMessage = `${label} is not valid`;
        break;
      default:
      // no op
    }
    if (toggleValue.indexOf(name) > -1 && !submit) {
      value = display;
    }
    return /*#__PURE__*/_jsxs("div", {
      className: classes,
      children: [/*#__PURE__*/_jsxs("label", {
        htmlFor: id,
        children: [label, required ? /*#__PURE__*/_jsx("span", {
          className: "required",
          children: "*"
        }) : null]
      }), info.length > 0 ? /*#__PURE__*/_jsx(Info, {
        info: info
      }) : null, /*#__PURE__*/_jsx("input", {
        autoComplete: autoComplete,
        id: id,
        name: name,
        onBlur: e => onBlur(e.target.value),
        onChange: e => handleChange(e.target.value),
        placeholder: placeholder,
        type: type,
        value: value,
        inputMode: inputMode
      }), /*#__PURE__*/_jsx(ErrorMessage, {
        message: errorMessage,
        error: error
      })]
    });
  }
}
_defineProperty(TextInput, "defaultProps", {
  info: '',
  jest: false,
  label: 'First name',
  name: 'firstName',
  placeholder: '',
  section: 'personal-details',
  type: 'text',
  inputMode: 'text',
  values: {
    ...FIELDS
  }
});
export default TextInput;